import { useEffect, useMemo, useRef, useState } from 'react';
import { getCheapestByPrice } from '../helpers';

export const useClusterSelection = element => {
  const [activeRadio, setActiveRadio] = useState([]);
  const [activeCluster, setActiveCluster] = useState({});
  const [nextLegOptions, setNextLegOptions] = useState([]);

  const refNextLeg = useRef();

  const cheapestCombination = useMemo(
    () => getCheapestByPrice(element?.combinations),
    [element]
  );

  const cheapestNextLegOption = useMemo(
    () => getCheapestByPrice(cheapestCombination?.next_leg_options),
    [cheapestCombination]
  );

  const clusterId =
    cheapestNextLegOption?.cluster_id ?? cheapestCombination?.cluster_id;

  useEffect(() => {
    if (!cheapestCombination) {
      return;
    }

    const cheapestFlightOption = cheapestCombination.option;
    const legNextLegOptions = cheapestCombination.next_leg_options || [];

    setNextLegOptions(legNextLegOptions);

    if (cheapestNextLegOption) {
      const firstOption = { ...cheapestFlightOption };

      if (cheapestNextLegOption.first_option_id) {
        firstOption.id_option = cheapestNextLegOption.first_option_id;
      }

      const secondOption = { ...cheapestNextLegOption.option };

      setActiveRadio([firstOption, secondOption]);
    } else {
      setActiveRadio([cheapestFlightOption]);
    }

    setActiveCluster(
      cheapestNextLegOption?.cluster ?? cheapestCombination.cluster
    );
  }, [element]);

  const handleRadio = (
    index,
    object_option,
    next_leg_options,
    next_cluster
  ) => {
    //validamos si es busqueda personalizadad
    if (index == 0 && next_leg_options) {
      const cheapestNextLeg = getCheapestByPrice(next_leg_options);

      setActiveRadio([object_option, cheapestNextLeg?.option]);
      setNextLegOptions(next_leg_options);

      if (refNextLeg.current) {
        refNextLeg.current.scrollTop = 0;
      }
    } else {
      setActiveRadio(prevState => {
        const newState = [...prevState];
        //seteamos el id_option de la primera opcion
        newState[0] = {
          ...newState[0],
          id_option: object_option?.first_option_id,
        };
        //eliminamos first_option_id de la segunda opcion
        const newObject_option = { ...object_option };
        delete newObject_option.first_option_id;
        newState[index] = newObject_option;
        return newState;
      });
    }

    setActiveCluster(next_cluster);
  };

  return {
    activeRadio,
    activeCluster,
    nextLegOptions,
    handleRadio,
    clusterId,
    refNextLeg,
  };
};
